import React from 'react';
import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { AnnouncementCardSkeletonProps } from './AnnouncementCardSkeleton.types';

const AnnouncementCardSkeleton: React.FC<AnnouncementCardSkeletonProps> = ({
    className,
    rightContent,
    strip,
}) => {
  return (
      <Card className={`relative flex pt3 width-100 ${className}`} loading={true} strip={strip}>
        <div className="flex flex-column width-100">
          <div className="flex flex-justify">
            <div className="flex flex-row ml4">
              <Skeleton
                width={32}
                height={32}
                variant="circle"
                className="mt3"
              />
              <div className="flex flex-column ml4 mb3">
                <BaseSkeleton width={200} height={40} className="ml2" />
                <BaseSkeleton width={200} height={18} className="ml2" />
              </div>
            </div>
            {rightContent && (
              <div className="flex pr4">
                <BaseSkeleton  className="mt3" width={82}
                  height={45} />
              </div>
            )}
          </div>
        </div>
      </Card>
  );
};

export default AnnouncementCardSkeleton;
export { AnnouncementCardSkeletonProps };
